import { Outlet } from 'react-router-dom';
import { Sidebar, TopBar } from '@/components/layout';
import {
  SessionGate,
  ProfileCompletionGate,
  ProtectedRoute,
  StaffIdentityGate,
} from '@/features/auth';
import { LiveStatus } from '@/features/dashboard/components/LiveStatus';
import styles from './AdminLayout.module.css';

export function AdminLayout() {
  return (
    <SessionGate>
      <StaffIdentityGate>
        <ProfileCompletionGate>
          <div className={styles.layout}>
          <Sidebar />
          <div className={styles.main}>
            <TopBar />
            <main className={styles.content}>
              {/* Связь с сервером — на одном месте во всех разделах:
                  правый верхний угол области содержимого, вровень с заголовком. */}
              <div className={styles.connection}>
                <LiveStatus />
              </div>
              <ProtectedRoute>
                <Outlet />
              </ProtectedRoute>
            </main>
          </div>
          </div>
        </ProfileCompletionGate>
      </StaffIdentityGate>
    </SessionGate>
  );
}
